module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel box-collapse border-color-skin",
    attrs: {
      "id": "hres4ax-popup2-tab2"
    }
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed  tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion2",
      "href": "#popup2tab2"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['STDPOSP2']['10']) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "popup2tab2"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive panel-detail-filter"
  }, [_c('hrms-table', {
    attrs: {
      "columns": _vm.popup2Tab2Table,
      "data": _vm.data,
      "searchDisp": false
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0a0d61b6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres4ax/popup2Tab2.vue
// module id = 3530
// module chunks = 1